import {Provider} from '@/api/models/Providers.ts';
import {ConfirmFn} from '@/components/ConfirmDeleteDialog';
import ConfirmDialog, {ConfirmDialogProps, ControlState} from '@/components/ConfirmDialog.tsx';
import {ReactElement, useCallback, useState} from 'react';

interface Props extends ConfirmDialogProps {
	provider: Provider,
	onConfirm: ConfirmFn,
}

export default function ConfirmPasswordResetDialog({provider, onConfirm, ...props}: Props): ReactElement {
	const [saving, setSaving] = useState(false);

	const onConfirmInternal = useCallback(async () => {
		if (saving)
			return;

		setSaving(true);
		await onConfirm();
		setSaving(false);
	}, [onConfirm, saving]);

	let controlState = saving ? ControlState.Loading : ControlState.Normal;

	return (
		<ConfirmDialog
			title="Confirm Password Reset"
			controlState={controlState}
			onConfirm={onConfirmInternal}
			{...props}
		>
			<p>
				Are you sure you want to reset the password for <strong>{provider.username}</strong>?
			</p>

			<p>
				Proceeding will change this provider's SFTP login password, and will require the new password be sent to
				them before feeds can be uploaded. Until the password is updated in the inventory provider's system, no
				feeds will be updated from that provider.
			</p>
		</ConfirmDialog>
	);
}
